import React from 'react';
import { Table, Badge, Input } from 'reactstrap';
import RoundedDropdown from '../../../Component/BasicComponents/Dropdowns/RoundedDropdown';

const PrescriberLadder: React.FC = () => {
  const doctors = 107;

  const data = [
    {
      name: 'Crina Ncr',
      feb: { rx: 68, nonRx: 39 },
      jan: { rx: 76, nonRx: 31 },
      dec: { rx: 75, nonRx: 32 },
    },
    {
      name: 'Vehycal Xt',
      feb: { rx: 41, nonRx: 66 },
      jan: { rx: 46, nonRx: 61 },
      dec: { rx: 50, nonRx: 57 },
    },
    {
      name: 'Isofit',
      feb: { rx: 43, nonRx: 64 },
      jan: { rx: 46, nonRx: 61 },
      dec: { rx: 47, nonRx: 60 },
    },
    {
      name: 'Folinal',
      feb: { rx: 0, nonRx: 107 },
      jan: { rx: 0, nonRx: 107 },
      dec: { rx: 0, nonRx: 107 },
    },
    {
      name: 'Lactonic',
      feb: { rx: 0, nonRx: 107 },
      jan: { rx: 0, nonRx: 107 },
      dec: { rx: 0, nonRx: 107 },
    },
    {
      name: 'New Vehycal',
      feb: { rx: 0, nonRx: 107 },
      jan: { rx: 0, nonRx: 107 },
      dec: { rx: 0, nonRx: 107 },
    },
    {
      name: 'Richglow',
      feb: { rx: 0, nonRx: 107 },
      jan: { rx: 0, nonRx: 107 },
      dec: { rx: 0, nonRx: 107 },
    },
  ];

  return (
    <div
      
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 style={{ fontWeight: 600 }}>Prescriber Ladder</h5>
        <div className="d-flex gap-2">
        <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=''
            backgroundColor='success'
          />
        <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=''
            backgroundColor='success'
          />
        </div>
      </div>

      <Table bordered responsive style={{ fontSize: 14, marginTop: 10 }}>
        <thead style={{ backgroundColor: '#EDF5FB' }}>
          <tr>
            <th style={{color:'#4E87BC'}}>Total Doctors</th>
            <th style={{color:'#4E87BC'}}>Non-Rxber</th>
            <th style={{color:'#4E87BC'}}>1 Brand Rxber</th>
            <th style={{color:'#4E87BC'}}>2 Brands Rxber</th>
            <th style={{color:'#4E87BC'}}>3 Brands Rxber</th>
            <th style={{color:'#4E87BC'}}>&gt;3 Brands Rxber</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{color:'#000',fontWeight:600}}>
            <td>{doctors}</td>
            <td>28</td>
            <td>21</td>
            <td>14</td>
            <td>44</td>
            <td>0</td>
          </tr>
        </tbody>
      </Table>

      <Table bordered responsive style={{ fontSize: 14, marginTop: 10 }}>
        <thead style={{ backgroundColor: '#ECF7F9', color: '#83AFC2' }}>
          <tr>
            <th></th>
            <th colSpan={2} style={{ textAlign: 'center' ,color:'#4E87BC'}}>February</th>
            <th colSpan={2} style={{ textAlign: 'center',color:'#4E87BC' }}>January</th>
            <th colSpan={2} style={{ textAlign: 'center',color:'#4E87BC' }}>December</th>
          </tr>
          <tr>
            <th style={{color:'#4E87BC'}}>Product Name</th>
            <th style={{color:'#4E87BC'}}>Rxber Count</th>
            <th style={{color:'#4E87BC'}}>Non-Rxber Count</th>
            <th style={{color:'#4E87BC'}}>Rxber Count</th>
            <th style={{color:'#4E87BC'}}>Non-Rxber Count</th>
            <th style={{color:'#4E87BC'}}>Rxber Count</th>
            <th style={{color:'#4E87BC'}}>Non-Rxber Count</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} style={{color:'#000',fontWeight:600}}>
              <td>{item.name}</td>
              <td>{item.feb.rx}</td>
              <td>{item.feb.nonRx}</td>
              <td>{item.jan.rx}</td>
              <td>{item.jan.nonRx}</td>
              <td>{item.dec.rx}</td>
              <td>{item.dec.nonRx}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PrescriberLadder;
